import React from 'react';
import RenderProps from '../../helpers/RenderProps';
import { useTheme } from '../../../hooks/theme/useTheme';
import useInput from '../Input';
import { roundToStep } from 'assets/utils/data/Number';
import { isValidValue } from 'assets/utils/parsersAndValidation/Validators';

export enum NumberInputStructure {
  formInput = 'formInput',
  input = 'input',
}
export type Verify = Utils.VerifyExtends<Component.Input.Number.Structure, typeof NumberInputStructure>;
export default function NumberInput<Name>(props: Component.Input.Number.Import<Name> & { integerOnly?: boolean }) {
  const extend = useTheme(NumberInputStructure, props);
  const { value, setValue } = useInput(props);

  const sanitizeInteger = (raw: string) => {
    const [whole] = raw.split('.');
    return whole;
  };
  return (
    <div
      {...extend(NumberInputStructure.formInput, true)}
      data-label={props.label}
      data-error={props.error || undefined}
      title={props.error ?? undefined}
      data-read-only={props.readOnly || undefined}
    >
      {RenderProps(props, 'iconBefore')}
      <input
        {...extend(NumberInputStructure.input)}
        type="number"
        readOnly={props.readOnly}
        min={props.min}
        max={props.max}
        step={props.integerOnly ? 1 : props.step}
        inputMode={props.integerOnly ? 'numeric' : undefined}
        pattern={props.integerOnly ? '\\d*' : undefined}
        value={isValidValue(value) ? value : ''}
        placeholder={props.placeholder}
        onKeyDown={(e) => {
          if (props.integerOnly && (e.key === '.' || e.key === ',')) {
            e.preventDefault();
          }
        }}
        onWheel={(event) => {
          if (!event.shiftKey) event.currentTarget.blur();
        }}
        onChange={(event) => {
          let raw = event.currentTarget.value;
          if (props.integerOnly) {
            raw = sanitizeInteger(raw);
          }
          setValue(isValidValue(raw) ? parseFloat(raw) : null);
        }}
        onClick={props.onClick}
        onBlur={
          !props.roundOnBlur
            ? undefined
            : (event) => {
                let raw = event.currentTarget.value;
                if (props.integerOnly) {
                  raw = sanitizeInteger(raw);
                  setValue(raw ? parseInt(raw, 10) : null);
                } else {
                  setValue(isValidValue(raw) ? roundToStep(parseFloat(raw), props.step || 0) : null);
                }
              }
        }
      />
      {RenderProps(props, 'icon')}
    </div>
  );
}
